module.exports = __webpack_public_path__ + "2e723d399660733d0a4b562e06f708a8.MP3";